import { render, staticRenderFns } from "./DownIcon.vue?vue&type=template&id=1a526365"
import script from "./DownIcon.vue?vue&type=script&lang=js"
export * from "./DownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports